import { localizeUrl } from '@shared/fondof-fn/url/localize'
import { gidToId } from '@shared/shop-api/core/helper'
import {
  getMetafieldJson,
  getMetafieldList,
  getMetafieldString,
} from '@shared/shop-api/metafield/mapper'
import type {
  BreadcrumbFragment,
  BreadcrumbItemFragment,
  CollectionFragment,
} from '@shared/types/storefront/graphql'

export const toBreadcrumbItem = (item: BreadcrumbItemFragment) => {
  return {
    id: 'id' in item ? item.id : undefined,
    title: 'title' in item ? item.title : undefined,
    handle: 'handle' in item ? localizeUrl(`/c/${item.handle}`) : undefined,
  }
}

export const toBreadcrumb = (
  breadcrumb: BreadcrumbFragment | undefined | null
) => {
  if (!breadcrumb) {
    return []
  }

  const nodes = breadcrumb.references?.nodes
  if (!Array.isArray(nodes)) {
    return []
  }
  const b = nodes
    .map((item) => toBreadcrumbItem(item as BreadcrumbItemFragment))
    .reverse()

  return b
}

export const toCategory = (collection: CollectionFragment) => {
  return {
    id: gidToId(collection.id),
    url: `/c/${collection.handle}`,
    handle: collection.handle,
    title: collection.title,
    description: collection.description,
    hreflang: getMetafieldJson(collection.metafields, 'hreflang'),
    seo: {
      ...collection.seo,
    },
    hero: getMetafieldString(collection.metafields, 'hero'),
    breadcrumb: toBreadcrumb(collection.breadcrumb),
    contentBeforeListing: getMetafieldString(
      collection.metafields,
      'content_before_listing'
    ),
    contentAfterListing: getMetafieldString(
      collection.metafields,
      'content_after_listing'
    ),
    contentInbetweenListing: getMetafieldList(
      collection.metafields,
      'content_inbetween_listing'
    ),
  }
}
